import { useEffect, useState } from 'react';
import {
  DEFAULT_LEARNING_RESTRICTIONS,
  FAILSAFE_LEARNING_RESTRICTIONS,
  subscribeLearningRestrictions,
  type LearningRestrictionSettings,
} from '@/utils/learningRestrictions';

export default function useLearningRestrictions() {
  const [settings, setSettings] = useState<LearningRestrictionSettings>(
    DEFAULT_LEARNING_RESTRICTIONS
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = subscribeLearningRestrictions(
      (data) => {
        setSettings(data);
        setLoading(false);
      },
      () => {
        setSettings(FAILSAFE_LEARNING_RESTRICTIONS);
        setLoading(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  return { settings, loading };
}
